import AddAndUpdateStaff from "pages/dashboard/shared/Users/Staffs/Add&UpdateStaffForm";

const AdminAddStaffs = () => {
  return <AddAndUpdateStaff redirectTo={`/admin/dashboard/users/staffs`} />;
};

export default AdminAddStaffs;
